import { UserRole } from '../../types/users';
import { SidebarConfig } from '../../types/navigation';
import { baseProjectSidebarConfig, limitedProjectSidebarConfig } from './pmo.sidebar';
import { hrmsAdminSidebarConfig, hrmsEmployeeSidebarConfig, hrmsManagerSidebarConfig } from './hrms.sidebar';
import { baseCrmSidebarConfig } from './crm.sidebar';

export { baseProjectSidebarConfig };

export const sidebarConfig: Record<UserRole, SidebarConfig> = {
  ORG_OWNER: {
    HRMS: hrmsAdminSidebarConfig,
    'Project Management': baseProjectSidebarConfig,
    CRM: baseCrmSidebarConfig,
  },
  ORG_ADMIN: {
    HRMS: hrmsAdminSidebarConfig,
    'Project Management': baseProjectSidebarConfig,
    CRM: baseCrmSidebarConfig,
  },
  HRM_ADMIN: {
    HRMS: hrmsAdminSidebarConfig,
    'Project Management': limitedProjectSidebarConfig,
  },
  HRM_MANAGER: {
    HRMS: hrmsManagerSidebarConfig,
    'Project Management': limitedProjectSidebarConfig,
  },
  HRM_EMPLOYEE: {
    HRMS: hrmsEmployeeSidebarConfig,
    'Project Management': limitedProjectSidebarConfig,
  },
  PMO_ADMIN: {
    'Project Management': baseProjectSidebarConfig,
    HRMS: hrmsEmployeeSidebarConfig,
  },
  PMO_MANAGER: {
    'Project Management': baseProjectSidebarConfig,
    HRMS: hrmsEmployeeSidebarConfig,
  },
  PMO_USER: {
    'Project Management': limitedProjectSidebarConfig,
    HRMS: hrmsEmployeeSidebarConfig,
  },
  CRM_ADMIN: {
    CRM: baseCrmSidebarConfig,
  },
  CRM_MANAGER: {
    CRM: baseCrmSidebarConfig,
  },
  CRM_USER: {
    CRM: baseCrmSidebarConfig,
  },
  EMPLOYEE: {
    HRMS: hrmsEmployeeSidebarConfig,
    'Project Management': limitedProjectSidebarConfig,
  },
  NONE: {},
};
